<template>
  <VAutocomplete
    v-model="VALOR_SELECIONADO"
    v-bind="$attrs"
    :items="itens"
    item-text="descricao"
    item-value="id"
    :loading="carregando_dados"
    v-on="INPUT_LISTENNER"
  >
    <template #progress>
      <v-progress-linear
        style="position: absolute"
        height="2px"
        :color="cor_loading"
        indeterminate
      ></v-progress-linear>
    </template>

    <template #prepend-item v-if="MULTIPLA_SELECAO_ATIVA && itens.length">
      <v-list-item
        v-if="VALOR_SELECIONADO.length === itens.length"
        class="pl-14px py-2"
        @click="VALOR_SELECIONADO = []"
      >
        <v-icon class="ml-2" color="primary">mdi-checkbox-marked</v-icon>
        <span class="ml-2 font-weight-medium">Desmarcar Todas</span>
      </v-list-item>

      <v-list-item
        v-else
        class="pl-14px py-2"
        @click="VALOR_SELECIONADO = Helpers.arrayColumn(itens, 'id')"
      >
        <v-icon v-if="VALOR_SELECIONADO.length > 0" class="ml-2" color="primary">mdi-minus-box</v-icon>
        <v-icon v-else class="ml-2">mdi-checkbox-blank-outline</v-icon>
        <span class="ml-2 font-weight-medium">Selecionar Todas</span>
      </v-list-item>

      <v-divider />
    </template>

    <template #selection="{item}" v-if="MULTIPLA_SELECAO_ATIVA">
      <template v-if="VALOR_SELECIONADO.indexOf(item.id) < qtde_visivel_selecionados">
        {{item.descricao }}<template v-if="apendarVirgula(item)">,&nbsp;</template>
      </template>

      <template v-if="VALOR_SELECIONADO.indexOf(item.id) === qtde_visivel_selecionados">
        <span class="ml-1 text-gray-100">(+ {{VALOR_SELECIONADO.length - qtde_visivel_selecionados}})</span>
      </template>
    </template>
  </VAutocomplete>
</template>

<script>
import {buscarCategoriasMPPA} from "@/api/compras/MateriaPrima";
import {logout} from "@/helpers";

export default {
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: [Array, Number],
    cor_loading: {
      type: String,
      default: 'red'
    },
    qtde_visivel_selecionados: {
      type: Number,
      default: 4
    },
  },
  data: () => ({
    itens: [],
    carregando_dados: false
  }),
  computed: {
    VALOR_SELECIONADO: {
      get() {
        return this.modelValue;
      },
      set(valor) {
        this.$emit('update:modelValue', valor);
      }
    },
    INPUT_LISTENNER() {
      const vm = this;
      return Object.assign({}, vm.$listeners);
    },
    MULTIPLA_SELECAO_ATIVA () {
      return ![null, undefined, false].includes(this.$attrs.multiple)
    },
  },
  mounted() {
    this.buscarItens();
  },
  methods: {
    buscarItens() {
      this.carregando_dados = true;

      buscarCategoriasMPPA()
        .then(itens => {
          this.itens = itens;
          this.carregando_dados = false;
        })
        .catch(logout);
    },
    apendarVirgula (item) {
      const indexOf = this.VALOR_SELECIONADO.indexOf(item.id)
      return indexOf !== this.VALOR_SELECIONADO.length - 1 && indexOf < (this.qtde_visivel_selecionados - 1)
    }
  }
}
</script>

<style scoped>

</style>
